import React, { useCallback, useEffect, useState } from 'react';
import Button from 'src/components/Button/Button';
import { Button as ButtonShad } from 'src/components/ui/button';
import { DialogFooter } from 'src/components/ui/dialog';
import { useAppSelector } from 'src/store';
import { ZendeskEmailStep5 } from 'src/pages/ControlDeskPage/IntegrationStatusSection/IntegrationsModal/IntegrationModalStep5/ZendeskEmailStep5/ZendeskEmailStep5';

const NextIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
    <path
      d="M0 5.0625L6.84562 5.0625L3.70125 8.20688L4.5 9L9 4.5L4.5 -9.81574e-10L3.70687 0.793125L6.84562 3.9375L0 3.9375V5.0625Z"
      fill="white"
    />
  </svg>
);
export const IntegrationModalStep5 = ({
  defaultBtnStyle,
  onClick = (_data?: any) => {},
  close = (_isLast?: any) => {},
}: {
  defaultBtnStyle?: boolean;
  onClick?: (data?: any) => void;
  close?: (isLast?: any) => void;
}) => {
  const config = { className: '' };
  const { selectedIntegration } = useAppSelector((s) => s.integrationSlices);
  const [formId, setFormId] = useState('integration-form');
  const isLastStep = selectedIntegration?.setupSteps === 5;

  useEffect(() => {
    if (selectedIntegration) {
      if (selectedIntegration.data.integration_type === 'zendesk_email') {
        setFormId('zendesk-email-step5-form');
      }
    }
  }, [selectedIntegration]);

  const renderStep5 = useCallback(() => {
    if (selectedIntegration) {
      switch (selectedIntegration.data.integration_type) {
        case 'zendesk_email':
          return <ZendeskEmailStep5 onClick={onClick} onClose={close} />;
      }
    }
  }, [selectedIntegration]);

  return (
    <>
      {renderStep5()}
      <DialogFooter>
        {!defaultBtnStyle ? (
          <>
            <Button
              style={{ width: 'auto', minWidth: '100px' }}
              className="transparent black"
              onClick={() => close(isLastStep)}
            >
              Cancel
            </Button>
            <Button
              style={{ width: 'auto', minWidth: '100px' }}
              type="submit"
              form="integration-form"
              className={config.className}
            >
              {isLastStep ? (
                'Launch'
              ) : (
                <>
                  Next <NextIcon />
                </>
              )}
            </Button>
          </>
        ) : (
          <div className="sticky bottom-0 w-full">
            <div className="flex w-full items-center justify-center gap-2.5 pb-6 pt-5">
              <ButtonShad
                type="button"
                variant="outline"
                className="transparent black min-w-28"
                onClick={() => close(isLastStep)}
              >
                Cancel
              </ButtonShad>
              <ButtonShad type="submit" className="min-w-28 gap-1.5" form={formId}>
                {isLastStep ? (
                  'Launch'
                ) : (
                  <>
                    Next <NextIcon />
                  </>
                )}
              </ButtonShad>
            </div>
          </div>
        )}
      </DialogFooter>
    </>
  );
};
